import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SelectItem} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/filter-select/select-item';

@Component({
    selector: 'app-component1',
    templateUrl: './component1.component.html',
    styleUrls: ['./component1.component.scss']
})
export class Component1Component implements OnInit, OnChanges {
    public item: SelectItem;

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
    }


}
